import React, { FC } from "react";

export const EuroCircle: FC<JSX.IntrinsicAttributes & { color?: string }> = (
  props
) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.03125 10.3125C5.63021 10.276 5.41146 10.0573 5.375 9.65625C5.41146 9.25521 5.63021 9.03646 6.03125 9H6.93359C7.33464 7.70573 8.0638 6.65755 9.12109 5.85547C10.1784 5.05339 11.4089 4.64323 12.8125 4.625H13.4688C13.8698 4.66146 14.0885 4.88021 14.125 5.28125C14.0885 5.68229 13.8698 5.90104 13.4688 5.9375H12.8125C11.7734 5.95573 10.862 6.23828 10.0781 6.78516C9.27604 7.35026 8.68359 8.08854 8.30078 9H12.5938C12.9948 9.03646 13.2135 9.25521 13.25 9.65625C13.2135 10.0573 12.9948 10.276 12.5938 10.3125H8.02734C8.00911 10.4583 8 10.6042 8 10.75C8 10.8958 8.00911 11.0417 8.02734 11.1875H12.5938C12.9948 11.224 13.2135 11.4427 13.25 11.8438C13.2135 12.2448 12.9948 12.4635 12.5938 12.5H8.30078C8.68359 13.4115 9.27604 14.1497 10.0781 14.7148C10.862 15.2617 11.7734 15.5443 12.8125 15.5625H13.4688C13.8698 15.599 14.0885 15.8177 14.125 16.2188C14.0885 16.6198 13.8698 16.8385 13.4688 16.875H12.8125C11.4089 16.8568 10.1784 16.4466 9.12109 15.6445C8.0638 14.8424 7.33464 13.7943 6.93359 12.5H6.03125C5.63021 12.4635 5.41146 12.2448 5.375 11.8438C5.41146 11.4427 5.63021 11.224 6.03125 11.1875H6.71484C6.69661 11.0417 6.6875 10.8958 6.6875 10.75C6.6875 10.6042 6.69661 10.4583 6.71484 10.3125H6.03125Z"
        fill="currentColor"
      />
      <rect
        x="0.5"
        y="0.5"
        width="21"
        height="21"
        rx="10.5"
        stroke="currentColor"
      />
    </svg>
  );
};
